// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".recaptcha-branding{margin-top:3rem;margin-bottom:3rem;margin-left:auto;margin-right:auto;text-align:center;color:var(--text-text-ternary);width:40rem}.recaptcha-branding a{color:var(--text-text-label);-webkit-transition:all .2s;transition:all .2s}.recaptcha-branding a:hover{--text-opacity:1;color:#e04067;color:rgba(224,64,103,var(--text-opacity))}@media(max-width:767.98px){.recaptcha-branding{margin-left:1.5rem;margin-right:1.5rem;width:auto}}", ""]);
// Exports
module.exports = exports;
